import { SpinnerProps } from '@blueprintjs/core';
import { StyledSpinner } from './Spinner.styles';

type Props = SpinnerProps & {
  color?: string;
};

export const Spinner = ({ color, ...rest }: Props) => {
  return <StyledSpinner {...rest} $color={color} />;
};
